<template>
  <v-bottom-sheet v-model="showMenu">
    <v-list>
      <v-subheader>
        Recent Documents
        <v-btn
          fab
          botom
          right
          absolute
          small
          color="primary"
          @click="openDocumentEditor()"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-subheader>

      <v-progress-linear
        v-show="loading"
        indeterminate
        :height="2"
        color="primary"
      />

      <v-list-item
        v-for="doc in projectDocuments"
        :key="doc.id"
        @click="openDocumentEditor(doc)"
      >
        <v-list-item-avatar>
          <v-icon>insert_drive_file</v-icon>
        </v-list-item-avatar>
        <v-list-item-title>{{ doc.title }}</v-list-item-title>
      </v-list-item>
    </v-list>

    <markdown-editor
      :document="currentDocument.id"
      :show.sync="showEditor"
    />
  </v-bottom-sheet>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import MarkdownEditor from './MarkdownEditor'
import { firestore } from '@/database'

export default {
  components: {
    MarkdownEditor
  },
  data () {
    return {
      projectDocuments: [],
      loading: false
    }
  },
  computed: {
    ...mapState('documents', [ 'currentDocument' ]),
    showEditor: {
      get () { return this.$store.state.documents.showEditor },
      set (val) { this.showDocumentsEditor(val) }
    },
    showMenu: {
      get () { return this.$store.state.documents.show },
      set (val) { this.showDocumentsMenu(val) }
    }
  },
  watch: {
    showMenu (val) {
      if (val) {
        this.projectDocuments = []
        this.updateRecentDocs()
      }
    }
  },
  methods: {
    ...mapMutations('documents', [
      'showDocumentsEditor',
      'showDocumentsMenu'
    ]),
    openDocumentEditor (document = {}) {
      this.showDocumentsEditor(document)
      this.showMenu = false
    },
    getContextFilter () {
      // If i'm on a project page the fetch latest project docs
      if (this.$route.name.startsWith('project-')) {
        return [ 'project', '==', this.$route.params.name ]
      } else {
        // otherwise get all organization docs
        return [ 'organization', '==', this.$currentOrganization.id ]
      }
    },
    updateRecentDocs () {
      this.loading = true

      firestore.collection('attachments')
        .where(...this.getContextFilter())
        .orderBy('updatedAt', 'desc')
        .limit(10)
        .get()
        .then(querySnapshot => {
          this.projectDocuments = []
          querySnapshot.forEach(doc => {
            const x = doc.data()
            Object.defineProperty(x, 'id', { value: doc.id, enumerable: false })
            this.projectDocuments.push(x)
          })
        })
        .catch(err => {
          this.$notifyError('Can\'t get recent documents', err)
        })
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>

</style>
